import { useState } from 'react';
import { useBulkMovePipeline } from '@/hooks/useDeals';
import { usePipelines } from '@/hooks/usePipelines';
import { Button, Modal, Select } from '@solid/ui';

export function BulkMovePipelineDialog({
  dealIds,
  currentPipelineId,
  open,
  onOpenChange,
  onSuccess,
}: {
  dealIds: string[];
  currentPipelineId?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}) {
  const [targetPipelineId, setTargetPipelineId] = useState('');
  const { data: pipelines } = usePipelines();
  const bulkMove = useBulkMovePipeline();
  const count = dealIds.length;

  const pipelineOptions = (pipelines ?? [])
    .filter((p) => p.id !== currentPipelineId)
    .map((p) => ({ value: p.id, label: p.name }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!targetPipelineId) return;
    await bulkMove.mutateAsync({ dealIds, targetPipelineId });
    setTargetPipelineId('');
    onOpenChange(false);
    onSuccess();
  };

  return (
    <Modal
      open={open}
      onOpenChange={(v) => { if (!v) setTargetPipelineId(''); onOpenChange(v); }}
      title="Move Deals to Pipeline"
      description={`Move ${count} deal${count !== 1 ? 's' : ''} to a different pipeline. Deals will be placed in the first active stage.`}
      footer={
        <>
          <Button variant="ghost" onClick={() => { setTargetPipelineId(''); onOpenChange(false); }}>
            Cancel
          </Button>
          <Button
            type="submit"
            form="bulk-move-pipeline-form"
            disabled={!targetPipelineId}
            loading={bulkMove.isPending}
          >
            Move {count} Deal{count !== 1 ? 's' : ''}
          </Button>
        </>
      }
    >
      <form id="bulk-move-pipeline-form" onSubmit={handleSubmit} className="space-y-4">
        <Select
          label="Target Pipeline"
          required
          value={targetPipelineId}
          onChange={(e) => setTargetPipelineId(e.target.value)}
          placeholder="Select a pipeline..."
          options={pipelineOptions}
        />
      </form>
    </Modal>
  );
}
